import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@barracuda-internal/bds-core';
import { actions as authActions } from './authReducer';

/**
 * Shown when the user is not yet authenticated.
 * Dispatches checkSession() which triggers the auth saga:
 *   - If the backend returns {url: ...}, the saga redirects to Azure AD.
 *   - If the backend returns {authenticated: true, ...}, the store updates
 *     and App re-renders the authenticated shell.
 */
const LoginContainer = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((s) => s.auth.isLoading);

  useEffect(() => {
    dispatch(authActions.checkSession());
  }, [dispatch]);

  // Either we're loading (about to redirect to Azure) or
  // we've already redirected (this component won't be visible).
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoginContainer;
